import InvitationForm from "@components/auth/invitation-form";
import AuthLayout from "./layout";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { LOGIN_PAGE_ROUTE } from "@pma/utils/page-routes";
import { useEffect } from "react";
import axios from "axios";
import { SERVER_URL, VALIDATE_INVITE_ENDPOINT } from "@pma/utils/api-routes";
import { useQuery } from "@tanstack/react-query";
import PmsLoader from "@components/common/loader";
import { toast } from "@hooks/use-toast";
import useTranslator from "@hooks/use-translator";
import { DictType } from "@pma/types";
import { Button } from "@components/common/button";

import { useAuth } from "@stores/auth-store";

const InvitationsPage = () => {
  const inviteParam = useSearchParams()[0].get("key");
  const navigate = useNavigate();
  const { translate } = useTranslator();
  const { signIn } = useAuth();

  const validateKey = async () => {
    const response = await axios.get(
      SERVER_URL + VALIDATE_INVITE_ENDPOINT + `?key=${inviteParam}`,
    );

    return response.data;
  };

  const { data, isLoading, error, isFetched } = useQuery({
    queryKey: ["validate-invite-key", inviteParam],
    queryFn: validateKey,
    enabled: !!inviteParam,
    retry: 2,
  });

  useEffect(() => {
    // Prevent access of the page if there is no invitation key
    if (!inviteParam) {
      navigate(LOGIN_PAGE_ROUTE);
    } else {
      // Save invitation to state
      signIn({ invitationKey: inviteParam });
    }
  }, []);

  useEffect(() => {
    // Route to login for existing user invitation workflow
    if (isFetched && !data) {
      navigate(LOGIN_PAGE_ROUTE);
    }
  }, [data, isFetched]);

  if (isLoading || error) {
    const message = error as DictType;
    error &&
      toast({
        title: translate("Error"),
        description: translate(message?.response?.data?.message) ||
          translate("Invalid invite key"),
        variant: "error",
      });
    return (
      <AuthLayout>
        <PmsLoader
          label={message?.response?.data?.message || "Validating key"}
        />

        <Link to={LOGIN_PAGE_ROUTE}>
          <Button className="mt-2 rounded-full capitalize">
            {translate("Back to Login")}
          </Button>
        </Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <InvitationForm inviteKey={String(inviteParam)} />
    </AuthLayout>
  );
};

export default InvitationsPage;
